/* eslint-disable */
import session from './session';

export default {
    getCellList(filter) {
        return session.get(`cell/${filter}`);
    },
    getCell(id) {
        return session.get(`cell/${id}/`);
    },
    createCell(data) {
        return session.post(`cell/`, data);
    },
    updateCell(id, data) {
        return session.patch(`cell/${id}/`, data );
    },
    deleteCell(id) {
        return session.delete(`cell/${id}/`);
    },
    activateCell(id) {
        return session.post(`cell/${id}/activate/`);
    },
    replaceCellBoard(id) {
        return session.post(`cell/${id}/replace-board/`);
    },
};